package com.appsyde.shared.presentation.screen.component.history

import androidx.compose.runtime.Composable
import com.appsyde.shared.app.presentation.ticket.HistoryState
import com.appsyde.shared.app.presentation.ticket.OriginalHistoryState
import com.appsyde.shared.presentation.screen.component.SpacerSmall
import com.appsyde.shared.presentation.style.style.AppStylesHistory
import org.jetbrains.compose.web.dom.*

enum class HistoryContentMode {
    SUMMARY,
    ORIGINAL
}

@Composable
fun HistorySection(
    history: HistoryState,
    originalHistory: OriginalHistoryState,
    hasHistory: Boolean,
    contentMode: HistoryContentMode,
    onChangeMode: (HistoryContentMode) -> Unit,
    onCollapse: () -> Unit
) {
    if (!hasHistory) return
    if (history is HistoryState.Hidden) return

    val hintText = when (contentMode) {
        HistoryContentMode.SUMMARY -> when (history) {
            is HistoryState.Loaded -> "${history.items.size} message(s) • Résumé"
            is HistoryState.Loading -> "Chargement…"
            is HistoryState.Error -> "Erreur"
            is HistoryState.Hidden -> ""
        }

        HistoryContentMode.ORIGINAL -> when (originalHistory) {
            is OriginalHistoryState.Loaded -> "${originalHistory.items.size} message(s) • Originaux"
            is OriginalHistoryState.Loading -> "Chargement…"
            is OriginalHistoryState.Error -> "Erreur"
            is OriginalHistoryState.Hidden -> "—"
        }
    }

    Div(attrs = { classes(AppStylesHistory.historyPanel) }) {

        Div(attrs = { classes(AppStylesHistory.historyPanelHeader) }) {

            Div(attrs = { classes(AppStylesHistory.historyHeaderLeft) }) {
                Span(attrs = { classes(AppStylesHistory.historyPanelTitle) }) { Text("Messages précédents") }
                Span(attrs = { classes(AppStylesHistory.historyPanelHint) }) { Text(hintText) }
            }

            Div(attrs = { classes(AppStylesHistory.historyPanelActions) }) {
                HistoryModeSelector(mode = contentMode, onChange = onChangeMode)

                Button(attrs = {
                    classes(AppStylesHistory.historyCloseButton)
                    onClick { onCollapse() }
                }) {
                    Span(attrs = { classes(AppStylesHistory.historyCloseText) }) { Text("Masquer") }
                    Span(attrs = { classes(AppStylesHistory.historyCloseChevron) }) { Text("▴") }
                }
            }
        }

        when (contentMode) {
            HistoryContentMode.SUMMARY -> when (history) {
                is HistoryState.Error -> {
                    Div(attrs = { classes(AppStylesHistory.historyErrorInline) }) {
                        Text(history.message)
                    }
                }

                is HistoryState.Loaded -> {
                    Div(attrs = { classes(AppStylesHistory.historyList) }) {
                        history.items.forEach { item ->
                            Div(attrs = { classes(AppStylesHistory.historyItemWrap) }) {
                                Div(attrs = { classes(AppStylesHistory.historyDot) })
                                Div(attrs = { classes(AppStylesHistory.historyContentWrap) }) {
                                    HistorySummaryItemRow(item = item)
                                }
                            }
                        }
                    }
                }

                else -> Unit
            }

            HistoryContentMode.ORIGINAL -> when (originalHistory) {
                is OriginalHistoryState.Error -> {
                    Div(attrs = { classes(AppStylesHistory.historyErrorInline) }) {
                        Text(originalHistory.message)
                    }
                }

                is OriginalHistoryState.Loaded -> {
                    Div(attrs = { classes(AppStylesHistory.historyList) }) {
                        originalHistory.items.forEach { item ->
                            Div(attrs = { classes(AppStylesHistory.historyItemWrap) }) {
                                Div(attrs = { classes(AppStylesHistory.historyDot) })
                                Div(attrs = { classes(AppStylesHistory.historyContentWrap) }) {
                                    HistoryOriginalItemRow(item = item)
                                }
                            }
                        }
                    }
                }

                else -> Unit
            }
        }
    }

    SpacerSmall()
    HistoryPresentSeparator()
    SpacerSmall()
}
